import { z } from 'zod'

const userSchema = z.object({
  __typename: z.literal('user').default('user'),
  id: z.string(),
  role: z.enum(['ADMIN', 'USER', 'SUBSCRIBED_USER']),
  notionDatabaseId: z.string().nullable(),
  isTelegramSubscriber: z.boolean(),
  trialQuoteLimit: z.number(),
  paymentSubscriptionStatus: z.enum(['ACTIVE', 'INACTIVE']),
})

type User = z.infer<typeof userSchema>

const workSchema = z.object({
  __typename: z.literal('work').default('work'),
  id: z.string(),
  userId: z.string(),
})

type Work = z.infer<typeof workSchema>

const customListSchema = z.object({
  __typename: z.literal('custom-list').default('custom-list'),
  id: z.string(),
  ownerId: z.string(),
})

type CustomList = z.infer<typeof customListSchema>

export { userSchema, workSchema, customListSchema }
export type { Work, User, CustomList }
